import { ChartActions } from '@mode/charts/domain';

export const actionToDescriptionMap = {
  [ChartActions.updateType.type]: 'update chart type',
  [ChartActions.updateEncoding.type]: 'update encoding',
  [ChartActions.updateEncodingAndFormat.type]: 'update encoding and format',
  [ChartActions.swapAxes.type]: 'swap axes',
  [ChartActions.removeSort.type]: 'remove sort',
  [ChartActions.quickSort.type]: 'quick sort',
  [ChartActions.clearChart.type]: 'clear chart',
  [ChartActions.clearFilters.type]: 'clear filters',
  [ChartActions.clearSorts.type]: 'clear sorts',
  [ChartActions.clearFormatting.type]: 'clear formatting',
  [ChartActions.updateFieldFormat.type]: 'update field text format',
  [ChartActions.updateFieldColor.type]: 'update field color mapping',
  [ChartActions.updateExplorationColors.type]: 'update colors',
  [ChartActions.updateExplorationFieldColor.type]: 'update field color mapping',
  [ChartActions.updateDesignerFieldColor.type]: 'update field color mapping',
  [ChartActions.updateFormat.type]: 'change chart format',
  [ChartActions.updateAxisFieldFormat.type]: 'update field axisFormat',
  [ChartActions.updateHeaderFieldFormat.type]: 'update field headerFormat',
  [ChartActions.updateLegendFieldFormat.type]: 'update field legendFormat',
  [ChartActions.updatePaneFieldFormat.type]: 'update field paneFormat',
};

export const updateEncodingActions = [
  ChartActions.updateType,
  ChartActions.updateEncoding,
  ChartActions.updateEncodingAndFormat,
  ChartActions.swapAxes,
  ChartActions.removeSort,
  ChartActions.quickSort,
  ChartActions.clearChart,
  ChartActions.clearFilters,
  ChartActions.clearSorts,
];

export const updateFormatOrColorActions = [
  ChartActions.clearFormatting,
  ChartActions.updateFieldFormat,
  ChartActions.updateFieldColor,
  ChartActions.updateExplorationColors,
  ChartActions.updateExplorationFieldColor,
  ChartActions.updateDesignerFieldColor,
  ChartActions.updateFormat,
  ChartActions.updateAxisFieldFormat,
  ChartActions.updateHeaderFieldFormat,
  ChartActions.updateLegendFieldFormat,
  ChartActions.updatePaneFieldFormat,
];

export function isUpdateChartAction(action: string | undefined) {
  return action !== undefined
    ? Object.values(actionToDescriptionMap).some((description) => description === action)
    : false;
}

export function isUpdateFormatOrColorAction(action: string | undefined) {
  return action !== undefined ? updateFormatOrColorActions.some((change) => change.type === action) : false;
}
